import React from 'react';

import KakaoMap from './KakaoMap';

interface MapModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MapModal: React.FC<MapModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="map-modal-backdrop" onClick={onClose}>
      <div className="map-modal-content" onClick={e => e.stopPropagation()}>
        <header className="map-modal-header">
          <h3>주변 상담센터 찾기</h3>
          <button onClick={onClose} className="close-btn">&times;</button>
        </header>
        <div className="map-container">
          <KakaoMap />
        </div>
      </div>
    </div>
  );
};

export default MapModal;
